package org.zq.flvtomp4.converter

enum class ConvertMode {
    /** 自动判断转封装还是转码，默认 */
    SMART,

    /** 不重新编码，速度最快 */
    REMUX,

    /** 转成 H.264 + AAC，兼容性最好 */
    TRANSCODE,
}
